import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import IcoTool1 from 'assets/images/tool/ico-left-tool-1.svg';
import IcoTool2 from 'assets/images/tool/ico-left-tool-2.svg';
import IcoTool3 from 'assets/images/tool/ico-left-tool-3.svg';
import IcoTool4 from 'assets/images/tool/ico-left-tool-4.svg';
import IcoTool5 from 'assets/images/tool/ico-left-tool-5.svg';
import IcoTool1A from 'assets/images/tool/ico-left-tool-1-active.svg';
import IcoTool2A from 'assets/images/tool/ico-left-tool-2-active.svg';
import IcoTool3A from 'assets/images/tool/ico-left-tool-3-active.svg';
import IcoTool4A from 'assets/images/tool/ico-left-tool-4-active.svg';
import IcoTool5A from 'assets/images/tool/ico-left-tool-5-active.svg';
import OlCore from '../../ol/OlCore';
import ObjectPoint from '../../ol/Object/ObjectPoint';
import { Feature } from 'ol';
import MiniPopup from './MiniPopup';
import LabelElement from '../molcures/LabelElement';
import OnOffButton from '../atoms/OnOffButton';
import Button from '../atoms/Button';
import IcoAdd from '../../assets/images/button/ico-add.svg';
import IcoArrowRight from '../../assets/images/tool/ico-arrow-right.svg';
import IcoArrowRightHover from '../../assets/images/tool/ico-arrow-right-hover.svg';
import jsonp from 'jsonp';

import SOOJOON from 'data/test3.geojson';
import axios from 'axios';
import { domainUrl, mySearchApiKey } from '../../service/common';
import { flushSync } from 'react-dom';
import { useRecoilState } from 'recoil';
import { loaderState } from '../../store/Atoms';
import { transWgsTo5186 } from '../../ol/projection';
import useTileMapUpload from '../../hooks/map/useTileMapUpload';
import OpenImage from './OpenImage';
import ObjectPhoto from '../../ol/Object/ObjectPhoto';
import Table from '../atoms/Table';
import { PopupSt } from '../../Popups/PopupPointList';
import SidePopup from './SidePopup';
import { useSiteAdd, useSiteDetail, useSites } from '../../hooks/RQuery/utils/sites';
import ObjectSite from '../../ol/Object/ObjectSite';
import MapOverlay from '../organisms/MapOverlay';
import { useCenterLayer, useEastLayer, useLayers } from '../../hooks/RQuery/utils/layers';
import OpenCsv from './OpenCsv';
import ObjectPolygon from '../../ol/Object/ObjectPolygon';

export const LeftToolGroupSt = {
  Wrap: styled.div`
    position: fixed;
    z-index: 1;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
  `,
  ToolBox: styled.div<{ $activeUrl: string }>`
    position: relative;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    &.active {
      > button {
        border: 2px solid rgba(255, 255, 255, 0.5);
        &:before {
          background: linear-gradient(to left, #0077a6, #00bea3);
        }
        &:after {
          background-image: url(${(p) => p.$activeUrl});
        }
        & + * {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  `,
  ToolBtn: styled.button<{ $url: string }>`
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 2px solid transparent;
    background: linear-gradient(to right, #0077a6, #00bea3);
    & + * {
      transition: 0.4s opacity;
      opacity: 0;
      visibility: hidden;
    }
    &:before,
    &:after {
      position: absolute;
      z-index: 2;
      content: '';
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &:before {
      width: 58px;
      height: 58px;
      background: #fff;
      border-radius: 50%;
    }
    &:after {
      width: 38px;
      height: 38px;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(${(p) => p.$url});
      background-size: contain;
    }
  `,
  UploadBtn: styled.button`
    padding: 0 8px;
    height: 24px;
    border-radius: 50px;
    background: #00bea3;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    word-break: keep-all;
  `,
  UploadLabel: styled.label`
    padding: 0 6px;
    height: 24px;
    border-radius: 50px;
    background: #00bea3;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    word-break: keep-all;
    cursor: pointer;
    & + input {
      display: none;
    }
  `,
};

const SiteToolSt = {
  Title: styled.strong`
    color: #091219;
    font-size: 16px;
    font-weight: 600;
    display: block;
    text-align: center;
    margin-bottom: 19px;
  `,
  List: styled.ul`
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    margin-bottom: 12px;
    min-height: 280px;
    max-height: 392px;
  `,
  Item: styled.li`
    cursor: pointer;
    height: 56px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:after {
      content: '';
      border-radius: 50%;
      box-sizing: border-box;
      width: 24px;
      height: 24px;
      border: 1px solid #82b7e3;
      background: #fff url(${IcoArrowRight}) no-repeat center;
    }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 34px);
      margin-right: 10px;
      color: #192640;
      font-size: 16px;
      font-weight: 400;
    }
    &:hover {
      background: #f2f8f9;
      &:after {
        border: 2px solid rgba(255, 255, 255, 0.5);
        background-color: #82b7e3;
        background-image: url(${IcoArrowRightHover});
      }
      span {
        font-weight: 600;
      }
    }
  `,
};

const PopupStyle = {
  Contain: styled.div`
    position: fixed;
    z-index: 100;
    right: 80px;
    top: 90px;
    height: calc(100% - 100px);
    transition: 0.4s;
    &.hide {
      right: -400px;
    }
  `,
  Wrap: styled.div`
    background: #fff;
    width: 400px;
    height: 100%;
    overflow-y: auto;
    li {
      padding: 10px;
      border-radius: 4px;
      &.active {
        border: 3px solid #2d9999;
      }
    }
  `,
  Inner: styled.div`
    padding: 10px;
  `,
  Button: styled.button`
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 60px;
    background: #fff;
  `,
  Dimmed: styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
  `,
  ImageArea: styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 10000;
    transform: translate(-50%, -50%);
    /* width: 48%; */
    /* min-width: 700px; */
    /* > img {
      width: 100%;
    } */
    #imageContainer {
      overflow: hidden;
      width: 860px;
      height: 645px;
      background-color: #fff;
      border: 1px solid #000000;
      border-radius: 8px;
      cursor: grab;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* object-fit: contain; */
        transition: transform 0.2s ease;
      }
    }
  `,
  Close: styled.button`
    position: fixed;
    z-index: 10000;
    right: 20px;
    top: 16px;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.5);
    &:before,
    &:after {
      content: '';
      width: 40px;
      height: 1px;
      position: absolute;
      left: 50%;
      top: 50%;
      background: #fff;
    }
    &:before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    &:after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &:hover {
      background: rgba(100, 100, 100, 0.5);
    }
  `,
};
interface LeftToolGroupProps {
  mapInstance?: OlCore;
  objectPoint?: ObjectPoint;
  objectPhoto?: ObjectPhoto;
  objectSite?: ObjectSite;
  objectPolygon?: ObjectPolygon;
  isObjectReady: boolean;
  setPoints: React.Dispatch<SetStateAction<Feature[]>>;
  onPopupState: (key: string) => void;
  zoom: number;
  bbox: { minX: number; minY: number; maxX: number; maxY: number };
}

export interface ImageDataProps {
  lat: number;
  lon: number;
  createdDate: Date;
  fileName: string;
  checked: boolean;
  data: any;
}
const LeftToolGroup = ({ mapInstance, objectPoint, objectPolygon, isObjectReady, setPoints, onPopupState, objectPhoto, objectSite, zoom, bbox }: LeftToolGroupProps) => {
  const memberId = sessionStorage.getItem('memberId')!;
  const { onChangeLocalTileLayer, resetTileLayer, toggleTileLayer, tileMap } = useTileMapUpload({ mapInstance, isObjectReady });
  const toolRef = useRef<any>(null);
  const isAuth = !!sessionStorage.getItem('token');
  const [toolState, setToolState] = useState([
    { name: '현장 이동', active: false },
    { name: '도근점', active: false },
    { name: '항공영상', active: false },
    { name: '경계 필지', active: false },
    // { name: '공공기준점', active: false, isAuth: true },
  ]);
  const [isShowTiles, setIsShowTiles] = useState(true);
  const [isShowPoints, setIsShowPoints] = useState(false);
  const [isShowPublicPoints, setIsShowPublicPoints] = useState(false);
  const [imageList, setImageList] = useState<ImageDataProps[]>([]);
  const [hide, setHide] = useState(false);
  const [fileList, setFileList] = useState<string[]>([]);
  const [imagePopup, setImagePopup] = useState('');
  const [siteArray, setSiteArray] = useState([]);
  const [selSiteId, setSelSiteId] = useState('');
  const { data: siteList } = useSites({ memberId });

  const { data: siteDetail } = useSiteDetail({ siteId: selSiteId });
  const [layerIds, setLayerIds] = useState({
    east: '',
    center: '',
  });
  const layerList = useLayers({ layerType: 'CTRL_POINT' });
  const eastData = useEastLayer({ zoom, bbox, isShowPoints, layerId: layerIds.east });
  const centerData = useCenterLayer({ zoom, bbox, isShowPoints, layerId: layerIds.center });

  useEffect(() => {
    if (!!layerList.data) {
      setLayerIds((prev) => {
        return { east: layerList.data.find((l) => l.srid === 5186 && l.isPublished)?.layerId, center: layerList.data.find((l) => l.srid === 5174 && l.isPublished)?.layerId };
      });
    }
  }, [layerList.data]);

  useEffect(() => {
    if (siteList) {
      setSiteArray(siteList);
    }
  }, [siteList]);

  //현장 상세
  useEffect(() => {
    if (siteDetail) {
      // 1. 현장 위치 이동
      objectSite?.moveSite(siteDetail);
      setToolState((prev) => {
        const newArr = [...prev];
        newArr.map((i) => {
          i.active = false;
        });
        return newArr;
      });
    }
  }, [siteDetail]);

  //Tool 클릭
  const onClickTool = (num) => {
    const newArr = [...toolState];
    newArr.map((i, index) => {
      if (i.active) {
        i.active = false;
      } else {
        i.active = num === index;
      }
    });
    setToolState(newArr);
  };

  //기준점 on/off
  const onTogglePoint = (isPublic: boolean) => {
    isPublic ? setIsShowPublicPoints(!isShowPublicPoints) : setIsShowPoints(!isShowPoints);
  };

  useEffect(() => {
    if (eastData.data) {
      objectPoint?.drawEastArea(eastData.data);
    }
  }, [eastData.data]);

  useEffect(() => {
    if (centerData.data) {
      objectPoint?.drawCenterArea(centerData.data);
    }
  }, [centerData.data]);

  // 기준점 Point 그리기
  // useEffect(() => {
  //   if (isObjectReady) {
  //     objectPoint?.drawDogeun(); // 지적도근점
  //     objectPoint?.drawTriangle(); // 지적삼각점
  //     objectPoint?.drawAssistant(); // 지적삼각보조점
  //   }
  // }, [isObjectReady, objectPoint]);

  // 기준점 point 이벤트 추가
  useEffect(() => {
    if (isObjectReady) {
      objectPoint?.onClickPoint(setPoints); // click single point
      objectPoint?.dragBoxPoint(setPoints); // dragBox - multiple points select
    }
  }, [isObjectReady, objectPoint]);

  useEffect(() => {
    if (isObjectReady && siteList) {
      objectSite?.draw(siteList);
      objectSite?.select(setSelSiteId);
    } else {
      objectSite?.draw([]);
    }
  }, [isObjectReady, siteList]);

  //기준점 상세정보 호출
  const getPointInfo = (keyword) => {
    const url = '/openapi/search.json';
    const params = {
      target: 'point',
      refrnUrl: domainUrl,
      apikey: mySearchApiKey,
      keyword: keyword,
    };

    // URL에 파라미터 추가
    const queryString = Object.keys(params)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
    const fullUrl = `${url}?${queryString}`;

    jsonp(fullUrl, null, (err, data) => {
      if (err) {
        alert('일치하는 데이터가 없습니다.');
      } else {
        console.log('Data received:', data);
        const newData = data.search.contents.point?.filter((i) => i.ctrlpntNm === keyword)[0];
        console.log(newData);
      }
    });
    axios.get(fullUrl).then((res) => {
      console.log(res.data);
    });
  };

  //FIXME - 서버 작업 완료 후 api 적용
  useEffect(() => {
    axios.get(SOOJOON).then((res) => {
      // objectPoint?.draw(res.data);
      // objectPoint?.onClickStandard(getPointInfo);
    });
  }, [isObjectReady]);

  // //외부영역 클릭시 셀렉트박스 닫기
  // const handleClickOutSide = (e: MouseEvent) => {
  //   if (toolState.filter(({ active }) => active).length && !toolRef.current?.contains(e.target as Element)) {
  //     const newArr = [...toolState];
  //     newArr.map((i) => {
  //       i.active = false;
  //     });
  //     setToolState(newArr);
  //   }
  // };

  //지적도근점 on/off
  const onToggleLayer = () => {
    objectPoint?.onToggleLayer('DogeunLayer');
    objectPoint?.onToggleLayer('TriangleLayer');
    objectPoint?.onToggleLayer('AssistantLayer');
    objectPoint?.onToggleLayer('DogeunLayer2');
    objectPoint?.onToggleLayer('TriangleLayer2');
    objectPoint?.onToggleLayer('AssistantLayer2');
  };

  //항공사진 초기화
  const onReset = () => {
    setImageList([]);
    setFileList([]);
    (document.getElementById('fileUpload') as any).value = null;
    objectPhoto?.destroy();
  };

  const onChecked = (fileName: string) => {
    const newArr = [...imageList];
    newArr.map((i) => {
      i.checked = i.fileName === fileName;
    });
    // newArr.filter((i) => fileName === i.fileName)[0].checked = !newArr.filter((i) => fileName === i.fileName)[0].checked;
    objectPhoto?.onCheck(newArr.filter((i) => fileName === i.fileName)[0]);
    setImageList(newArr);
  };
  //
  // useEffect(() => {
  //   if (toolState.filter(({ active }) => active).length) document.addEventListener('mousedown', handleClickOutSide);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutSide);
  //   };
  // });

  const onClickSite = (id) => {
    setSelSiteId(id);
  };

  const onCloseOverlay = () => {
    objectSite?.init(setSelSiteId);
  };

  return (
    <>
      <LeftToolGroupSt.Wrap ref={toolRef}>
        {/* 현장이동 */}
        {isAuth && (
          <LeftToolGroupSt.ToolBox $activeUrl={IcoTool1A} className={toolState[0].active ? 'active' : ''}>
            <LeftToolGroupSt.ToolBtn type={'button'} $url={IcoTool1} onClick={() => onClickTool(0)}></LeftToolGroupSt.ToolBtn>
            <MiniPopup left={86} top={-66} width={278} $arrowTop={83}>
              <SiteToolSt.Title>현장이동</SiteToolSt.Title>
              <SiteToolSt.List className={'cScroll'}>
                {siteArray.map((i: any, index) => {
                  return (
                    <SiteToolSt.Item key={index} title={i.siteAlias} onClick={() => onClickSite(i.siteId)}>
                      <span>{i.siteAlias}</span>
                    </SiteToolSt.Item>
                  );
                })}
              </SiteToolSt.List>
              <Button
                text={'현장 추가'}
                height={56}
                $leftIco={IcoAdd}
                $isGradientBtn={true}
                onClick={() => {
                  onPopupState('siteAdd');
                  const newArr = [...toolState];
                  newArr.map((i) => {
                    i.active = false;
                  });
                  setToolState(newArr);
                }}
              />
            </MiniPopup>
          </LeftToolGroupSt.ToolBox>
        )}

        {/* 도근점 */}
        <LeftToolGroupSt.ToolBox $activeUrl={IcoTool2A} className={toolState[1].active ? 'active' : ''}>
          <LeftToolGroupSt.ToolBtn type={'button'} $url={IcoTool2} onClick={() => onClickTool(1)}></LeftToolGroupSt.ToolBtn>
          <MiniPopup left={86} top={-5} width={197} $arrowTop={23} padding={[14, 20]}>
            <LabelElement label={'지적도근점'}>
              <OnOffButton
                onClick={() => {
                  onTogglePoint(false);
                  onToggleLayer();
                }}
                active={isShowPoints}
              />
            </LabelElement>
          </MiniPopup>
        </LeftToolGroupSt.ToolBox>

        {/* 항공영상 */}
        <LeftToolGroupSt.ToolBox $activeUrl={IcoTool3A} className={toolState[2].active ? 'active' : ''}>
          <LeftToolGroupSt.ToolBtn type={'button'} $url={IcoTool3} onClick={() => onClickTool(2)}></LeftToolGroupSt.ToolBtn>
          <MiniPopup left={86} top={-20} $arrowTop={38}>
            <LabelElement label={'영상위치현황'} $labelWidth={93} id={'sky01'}>
              {/*<input type={'radio'} id={'sky01'} name={'skyView'} />*/}

              <OpenImage mapInstance={mapInstance} objectPhoto={objectPhoto} imageList={imageList} setImageList={setImageList} fileList={fileList} setFileList={setFileList} setHide={setHide} imagePopup={imagePopup} />
            </LabelElement>

            <LabelElement label={'정사 영상'} $labelWidth={93} id={'sky02'}>
              {/*<input type={'radio'} id={'sky02'} name={'skyView'} />*/}

              {!!tileMap ? (
                <>
                  <LeftToolGroupSt.UploadBtn type={'button'} onClick={resetTileLayer} style={{ marginRight: 6 }}>
                    초기화
                  </LeftToolGroupSt.UploadBtn>
                  <LeftToolGroupSt.UploadBtn
                    type={'button'}
                    onClick={() => {
                      toggleTileLayer(!isShowTiles);
                      setIsShowTiles(!isShowTiles);
                    }}
                  >
                    {isShowTiles ? '숨기기' : '보이기'}
                  </LeftToolGroupSt.UploadBtn>
                </>
              ) : (
                <>
                  <LeftToolGroupSt.UploadLabel htmlFor={'fileInput'}>업로드</LeftToolGroupSt.UploadLabel>
                  <input type="file" id="fileInput" {...{ webkitdirectory: '', mozdirectory: '', directory: '' }} onChange={onChangeLocalTileLayer} />
                </>
              )}
            </LabelElement>
          </MiniPopup>
        </LeftToolGroupSt.ToolBox>

        {/* 경계필지 */}
        <LeftToolGroupSt.ToolBox $activeUrl={IcoTool4A} className={toolState[3].active ? 'active' : ''}>
          <LeftToolGroupSt.ToolBtn type={'button'} $url={IcoTool4} onClick={() => onClickTool(3)}></LeftToolGroupSt.ToolBtn>
          <MiniPopup left={86} top={-5} $arrowTop={23}>
            <LabelElement label={'경계 필지'} $labelWidth={93} id={'divideField'}>
              {/*<input type={'radio'} id={'sky01'} name={'skyView'} />*/}

              <OpenCsv objectPolygon={objectPolygon} />
            </LabelElement>
          </MiniPopup>
        </LeftToolGroupSt.ToolBox>

        {/*/!* 공공기준점 *!/*/}
        {/*<LeftToolGroupSt.ToolBox $activeUrl={IcoTool4A} className={toolState[3].active ? 'active' : ''}>*/}
        {/*  <LeftToolGroupSt.ToolBtn type={'button'} $url={IcoTool4} onClick={() => onClickTool(3)}></LeftToolGroupSt.ToolBtn>*/}
        {/*  <MiniPopup left={86} top={-5} width={197} $arrowTop={23} padding={[14, 20]}>*/}
        {/*    <LabelElement label={'공공기준점'}>*/}
        {/*      <OnOffButton onClick={() => onTogglePoint(true)} active={isShowPublicPoints} />*/}
        {/*    </LabelElement>*/}
        {/*  </MiniPopup>*/}
        {/*</LeftToolGroupSt.ToolBox>*/}
      </LeftToolGroupSt.Wrap>

      {/*항공 사진*/}
      <>
        {imageList.length ? (
          <SidePopup
            left={hide ? '100%' : 'calc(100% - 480px - 20px)'}
            bottom={20}
            width={420}
            isHide={hide}
            padding={[0, 20, 20, 20]}
            onHide={() => setHide(!hide)}
            title={'항공 사진'}
            children={
              <>
                <LeftToolGroupSt.UploadBtn type={'button'} onClick={onReset} style={{ position: 'absolute', right: 20, top: 16 }}>
                  초기화
                </LeftToolGroupSt.UploadBtn>

                <div id={'imageList'} style={{ maxHeight: 700, overflow: 'scroll' }}>
                  <ul>
                    {imageList.map((i) => {
                      const date = new Date(i.createdDate);

                      const formatDate = () => {
                        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
                      };
                      return (
                        <li
                          style={{ marginBottom: 20, border: `4px solid ${i.checked ? '#56AEFFBD' : 'transparent'}`, borderRadius: 6 }}
                          key={i.fileName}
                          className={i.checked ? 'active' : undefined}
                          id={i.fileName}
                          onDoubleClick={() => {
                            setImagePopup(i.data);
                          }}
                          onClick={() => {
                            onChecked(i.fileName);
                          }}
                        >
                          <img src={i.data} style={{ width: '100%' }} alt={i.fileName} />
                          <div style={{ padding: 4 }}>
                            <p style={{ display: 'flex' }}>
                              <span style={{ width: 76 }}>파일명</span>
                              <span style={{ width: 'calc(100% - 76px)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={i.fileName}>
                                {i.fileName}
                              </span>
                            </p>
                            <p style={{ display: 'flex' }}>
                              <span style={{ width: 76 }}>촬영일시</span> {formatDate()}
                            </p>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </>
            }
          />
        ) : null}

        <div style={{ display: !!imagePopup ? 'block' : 'none' }}>
          <PopupStyle.Dimmed>
            <PopupStyle.ImageArea>
              <div id={'imageContainer'}>
                <PopupStyle.Close
                  type={'button'}
                  onClick={() => {
                    setImagePopup('');
                  }}
                ></PopupStyle.Close>
                <img id={'zoomableImage'} src={imagePopup} />
              </div>
            </PopupStyle.ImageArea>
          </PopupStyle.Dimmed>
        </div>
      </>

      <MapOverlay data={siteDetail} onClose={onCloseOverlay} siteId={selSiteId} />
    </>
  );
};

export default LeftToolGroup;
